import React from 'react'

const RadioGroup = ({ name, label, options, error, field, onChange }) => (
  <fieldset
    className="form-group row align-items-center radio-fieldset"
    aria-describedby={error ? `${name}-error` : undefined}
  >
    <legend className="col-12 col-form-label pt-0 mb-0">{label}</legend>
    <div className="col-auto d-flex align-items-center radio-group-gap">
      {options.map((opt) => (
        <div className="form-check form-check-inline mb-0" key={opt.value}>
          <input
            className={`form-check-input radio-size${
              error ? ' is-invalid' : ''
            }`}
            type="radio"
            name={name}
            value={String(opt.value)}
            id={`${name}-${opt.value}`}
            checked={String(field.value) === String(opt.value)}
            onChange={(e) => {
              // Debug log: print radio value and type
              console.log(
                'RadioGroup onChange value:',
                e.target.value,
                'type:',
                typeof e.target.value
              )
              // Always pass string value to form
              const event = {
                ...e,
                target: { ...e.target, value: String(e.target.value), name },
              }
              field.onChange(event)
              if (onChange) onChange(event)
            }}
            aria-invalid={!!error}
            aria-describedby={error ? `${name}-error` : undefined}
          />
          <label className="form-check-label" htmlFor={`${name}-${opt.value}`}>
            {opt.label}
          </label>
        </div>
      ))}
      {error && (
        <div id={`${name}-error`} className="invalid-feedback d-block ms-2">
          {error.message}
        </div>
      )}
    </div>
  </fieldset>
)

export default React.memo(RadioGroup)
